import { useTranslation } from 'react-i18next';
import { generatePath, useNavigate } from 'react-router-dom';

import { Utils, Button } from '@treezor/design-system';

import { IRestrictionGroupFormModalProps } from '../RestrictionGroupFormModal';

import { useAppDispatch } from '@/hooks/redux-helpers';
import { useConfirmationDialog } from '@/hooks/useConfirmationModal';

import { openModal } from '@/store/actions/core.actions';

import { deletePredefRestrictionsGroup } from '@/store/actions/predef-restrictions-group.actions';
import { IRestrictionsGroup } from '@/store/models/restriction.model';

import { useRoutepaths } from '@/router/hooks/useRoutePaths';

interface IRestrictionGroupActionProperties {
  restrictionsGroup: IRestrictionsGroup;
  isDisabled?: boolean;
}

export const RestrictionGroupActions = ({ restrictionsGroup, isDisabled }: IRestrictionGroupActionProperties) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const PathRoute = useRoutepaths();

  const toggleRestriction = () => {
    dispatch(
      openModal<IRestrictionGroupFormModalProps>('restrictionsPredefModal', {
        restrictionsGroupType: restrictionsGroup.type,
        restrictionsGroup,
        isDisabled,
        header: t('pages.administration.restrictionGroup.actions.updateRestriction.updateModal.header'),
      }),
    );
  };

  const RemoveRestriction = useConfirmationDialog({
    title: t('pages.administration.restrictionGroup.actions.updateRestriction.removeModal.header'),
    description: t('pages.administration.restrictionGroup.actions.updateRestriction.removeModal.description', {
      name: Utils.displayNameRestrictionUi(restrictionsGroup.name),
    }),
    confirm: {
      label: t('pages.administration.restrictionGroup.actions.updateRestriction.removeModal.ok'),
      action: () => dispatch(deletePredefRestrictionsGroup(restrictionsGroup)),
      color: 'danger',
    },
  });

  return (
    <div className="flex gap-4 items-center">
      <Button
        id="restriction-group-actions-modify-btn"
        type="button"
        size="s"
        variant="ghost"
        onClick={toggleRestriction}
        disabled={isDisabled}
      >
        {t('pages.cores.update').toUpperCase()}
      </Button>
      <Button
        id="restriction-group-actions-delete-btn"
        type="button"
        variant="ghost"
        size="s"
        color="danger"
        onClick={RemoveRestriction.toggle}
        disabled={isDisabled}
      >
        {t('pages.cores.delete').toUpperCase()}
      </Button>

      {restrictionsGroup.type === 'mid' && (
        <Button
          id="restriction-group-actions-detail-btn"
          type="button"
          variant="ghost"
          onClick={() =>
            navigate(
              generatePath(PathRoute.app.root, {
                '*': generatePath(PathRoute.app.restrictions.others, {
                  '*': generatePath(PathRoute.app.restrictions.details, {
                    groupId: `${restrictionsGroup.id}`,
                  }),
                }),
              }),
            )
          }
        >
          {t('pages.administration.restrictionGroup.actions.detailBtn').toUpperCase()}
        </Button>
      )}

      <RemoveRestriction.ConfirmationDialog />
    </div>
  );
};
